import { Pipe, PipeTransform } from "@angular/core";
import * as padStart from "core-js/fn/string/pad-start";

@Pipe({name: "breakLength", pure: true})
export class BreakLengthPipe implements PipeTransform {
    public transform(value: string): string {
        const digits = value.replace(/:/g, "");

        if (/[^0-9]/.test(digits) || digits === "") {
            return value;
        }

        const integer = parseInt(digits, 10);

        const minutes = Math.floor(integer / 10000);
        const seconds = Math.floor(integer / 100) % 100;
        const frames = integer % 100;

        if (frames === 0 && seconds === 0 && minutes === 0) {
            return "";
        }

        const formattedSeconds = padStart(seconds.toString(), 2, "0");
        const formattedFrames = padStart(frames.toString(), 2, "0");

        return `${minutes}:${formattedSeconds}:${formattedFrames}`
    }
}
